import { createActions, createState, createReducer } from 'reduxsauce-crud'

const DEEP = { deep: true }

export const UnvalidatedReceiptsRedux = createActions(
  {
    validateRequest: ['id'],
    validateSuccess: ['data'],
    validateFailure: ['errors'],
    sendToAccount: null,
    closeAccount: null,
    exportRequest: null,
    exportSuccess: null,
    exportFailure: ['error'],
  },
  {
    prefix: 'UNVALIDATED_VALIDATIONS_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = UnvalidatedReceiptsRedux
export const UnvalidatedReceiptsTypes = Types
export default Creators

export const INITIAL_STATE = createState({
  export: {
    fetching: false,
    error: null,
  },
}, {
  get: true,
})

const validateRequest = state => state.merge({}, DEEP)
const validateSuccess = (state, { data }) => state.merge({ get: { results: { data } } }, DEEP)
const validateFailure = (state, { errors }) => state.merge({ ...errors }, DEEP)

const sendToAccount = state => state.merge({ toProfile: true }, DEEP)
const closeAccount = state => state.merge({ toProfile: false }, DEEP)

const exportRequest = state => state.merge({ 
  export: { fetching: true, error: null } 
}, DEEP)

const exportSuccess = state => state.merge({ 
  export: { fetching: false, error: null } 
}, DEEP)

const exportFailure = (state, { error }) => state.merge({ 
  export: { fetching: false, error } 
}, DEEP)

export const reducer = createReducer(INITIAL_STATE, {
  [Types.validateRequest]: validateRequest,
  [Types.validateSuccess]: validateSuccess,
  [Types.validateFailure]: validateFailure,
  [Types.sendToAccount]: sendToAccount,
  [Types.closeAccount]: closeAccount,
  [Types.exportRequest]: exportRequest,
  [Types.exportSuccess]: exportSuccess,
  [Types.exportFailure]: exportFailure,
},
{
  defaultActions: {
    get: true,
  },
  Types,
},
)



// WEBPACK FOOTER //
// ./src/Data/Redux/UnvalidatedReceiptsRedux.js